// Socket 3D Model events
export const CAMERA_UPDATE = 'camera:update'
export const LAYER_ON = 'layer:on'
export const LAYER_OFF = 'layer:off'
export const OPACITY = 'opacity'

export const THREE_D_FOV = 45

// Constants for identifying layers. There are 32 possible layers
// Layer 0 is the default layer for all objects
// These should be the layer number, NOT the mask itself. THREE.js handles doing the bitshift
export enum LAYERS {
  DEFAULT = 0,
  HIGHLIGHT, // auto-increment
  SCENE2, // TODO: Effect composer in the future - brad & james
}
